const defaultConfig = {
  router: null,
  $vue: null,
  routeTrack: {
    enable: true,
    skipSamePath: true,
    transformQueryString: false,
    prependBase: false,
    ignoreRoutes: [
      '/survey/response',
      '/survey/end',
      '/survey/closed',
      '/survey/disabled',
    ],
  },
  eventTrack: {
    enable: true,
  },
};

const config = { ...defaultConfig };

export default config;
